import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';
import OutlineCreate from 'react-md-icon/dist/OutlineCreate';

import { Spinner } from '../../../index';
import './SubmitButton.scss';

const SubmitButton = ({
  disabled,
  submitting,
  defaultLabel,
  submittingLabel,
  onSubmit,
  wideButton,
}) => {
  let buttonText = defaultLabel;
  let buttonIcon = wideButton ? <OutlineCreate style={{ fontSize: '1.5rem' }} /> : null;
  if (submitting) {
    buttonText = submittingLabel;
    buttonIcon = <Spinner className="mr-2 float-left" />;
  }

  return (
    <Button
      color="primary"
      className={`btn-asure-submit d-flex align-items-center 
                ${wideButton ? 'wide-button justify-content-center' : ''}`}
      onClick={(e) => {
        e.preventDefault();
        onSubmit();
      }}
      disabled={disabled}
    >
      {buttonIcon}
      <FormattedMessage id={buttonText} />
    </Button>
  );
};

SubmitButton.defaultProps = {
  disabled: false,
  submitting: false,
  wideButton: false,
};

SubmitButton.propTypes = {
  disabled: PropTypes.bool,
  submitting: PropTypes.bool,
  defaultLabel: PropTypes.string.isRequired,
  submittingLabel: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  wideButton: PropTypes.bool,
};

export default SubmitButton;



// WEBPACK FOOTER //
// ./src/components/Forms/Components/SubmitButton/SubmitButton.jsx